export const TIER_UPGRADE_TOOLTIP =
  'Not available on your current plan. Contact your admin to upgrade.';

export const PERMISSION_TOOLTIP =
  "You don't have permission for this operation. Contact your admin.";

export function getDisabledReason(
  hasCapability: boolean,
  hasPermission: boolean
): string | undefined {
  if (!hasCapability) return TIER_UPGRADE_TOOLTIP;
  if (!hasPermission) return PERMISSION_TOOLTIP;
  return undefined;
}
